import React, {Component} from 'react';


export default class ToggleInput extends Component {

    render() {

        let className = this.props.toggleAction ? 'pointer toggle-input-div' : 'toggle-input-div';

        let noneAction = () => ({});
        let actionClear = this.props.toggleAction ? () => this.props.toggleAction(this.props.stateVar, false) : noneAction;
        let actionDone = this.props.toggleAction ? () => this.props.toggleAction(this.props.stateVar, true) : noneAction;

        let classCheck = this.props.selected === true ? 'green' : '';
        let classCheckText = this.props.selected === true ? 'white-text' : 'grey-text';
        let classClear = this.props.selected === false ? 'shell-grey' : '';
        let classClearText = this.props.selected === false ? 'white-text' : 'grey-text';

        return (
            <div className={`toggle-input ${this.props.className ? this.props.className : ''}`}>
                <span>{this.props.name}</span>
                <div className={`${className} ${classCheck}`} onClick={actionDone}>
                    <i className={`material-icons ${classCheckText}`}>done</i>
                </div>
                <div className={`${className} ${classClear}`} onClick={actionClear}>
                    <i className={`material-icons ${classClearText}`}>clear</i>
                </div>
            </div>
        );

    }
}

// TODO - Add proptypes required


// WEBPACK FOOTER //
// ./src/components/ToggleInput/toggleInput.js